import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import Typography from '@mui/material/Typography';
import classnames from 'classnames';

const useStyles = makeStyles((theme) => ({
  image: {
    width: 168,
    height: 94,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: theme.palette.grey[200],
    flexShrink: 0,
  },
  baseButton: {
    width: '100%',
    margin: `${theme.spacing(0.5)} 0`,
    padding: theme.spacing(1),
  },
  baseButtonSelected: {
    backgroundColor: theme.palette.grey[300],
  },
}));

const MediaItemPlayerCard = (props) => {
  const classes = useStyles();

  const { onSelectItem, mediaItem, selected } = props;
  const { thumbUrl } = mediaItem;

  return (
    <ButtonBase
      onClick={onSelectItem}
      className={classnames(classes.baseButton, {
        [classes.baseButtonSelected]: selected,
      })}
    >
      <Box
        display="flex"
        flexDirection="row"
        alignItems="flex-start"
        className={classes.item}
        width="100%"
      >
        <div
          className={classes.image}
          style={{ backgroundImage: `url(${thumbUrl})` }}
        />
        <Box
          ml={2}
          flexGrow={1}
          display="flex"
          flexDirection="column"
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <Typography gutterBottom variant="subtitle2">
            {mediaItem.name}
          </Typography>
        </Box>
      </Box>
    </ButtonBase>
  );
};

MediaItemPlayerCard.propTypes = {
  mediaItem: PropTypes.object,
  onSelectItem: PropTypes.func,
  selected: PropTypes.bool,
};

MediaItemPlayerCard.defaultProps = {
  mediaItem: {},
  selected: false,
  onSelectItem() {},
};

export default MediaItemPlayerCard;
